import { render } from "./XDialog.vue?vue&type=template&id=071eaab0"
import script from "./XDialog.vue?vue&type=script&lang=js"
export * from "./XDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__